<div class="n-oldalfej">
  <h2>Naplók</h2>
  <span class="n-alcim">{{ aktiv.ugyfelNev }} · {{ aktiv.ev }}</span>
</div>

<div class="n-fulek">
  <button *ngFor="let f of fulek" type="button" [class.aktiv]="ful === f.k" (click)="fulValt(f.k)">{{ f.c }}</button>
</div>

<div class="n-naplo">
  <!-- Műveletsáv -->
  <div class="n-rail">
    <button type="button" [class.aktiv]="aktivCimkek.length > 0" (click)="szukitesGomb()" [disabled]="!szukitesLehet"
            [title]="ful === 'kivonat' ? 'Dátum, főkönyvi szám, munkaszám, partner, devizanem szerinti szűkítés, alábontások' : 'Dátum, főkönyvi szám, munkaszám, partner, devizanem szerinti szűkítés'">
      <ion-icon name="funnel-outline"></ion-icon>Szűkítés
    </button>
    <button type="button" *ngIf="ful === 'penzugyi'" (click)="nyomtatvanyNyit()" title="Nyomtatványok (PDF)"><ion-icon name="documents-outline"></ion-icon>Nyomtatványok</button>
    <button type="button" (click)="keresoFokusz()" title="Gyorskeresés"><ion-icon name="search-outline"></ion-icon>Keresés</button>
    <button type="button" [class.aktiv]="osszegzes" (click)="osszegzes = !osszegzes" [disabled]="!osszegzesVan" title="Összesítő sor"><ion-icon name="calculator-outline"></ion-icon>Összegzés</button>
    <button type="button" (click)="nyomtat()" title="Nyomtatás"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button>
    <button type="button" (click)="exportal()" [disabled]="!lathatoSorok.length" title="Letöltés CSV-ben (Excel)"><ion-icon name="download-outline"></ion-icon>Exportálás</button>
    <button type="button" (click)="betolt()" title="Frissítés"><ion-icon name="refresh-outline"></ion-icon>Frissítés</button>
    <button type="button" *ngIf="kettos" (click)="ujraszamoz()" title="Minden napló bizonylatait a keltezés szerint újraszámozza (közbe könyvelés után automatikusan is megtörténik)"><ion-icon name="list-outline"></ion-icon>Újraszámozás</button>
    <button type="button" *ngIf="kettos" (click)="rlbNyit()" title="Pénzügyi nyilvántartás + pénztár-bank napló importja az RLB-ből"><ion-icon name="cloud-upload-outline"></ion-icon>RLB-import</button>
  </div>

  <div class="n-naplo-fo">
    <div class="n-kereso">
      <!-- Főkönyvi kartonok: melyik számla kartonja -->
      <ng-container *ngIf="ful === 'karton'">
        <label for="kartonSzla">Számla</label>
        <select id="kartonSzla" class="karton-valaszto" [(ngModel)]="szuro.szamla" (ngModelChange)="betolt()">
          <option value="*">Minden számla (forgalommal)</option>
          <option *ngFor="let s of kartonSzamlak" [value]="s.szamlaszam">{{ s.szamlaszam }} – {{ s.nev }}</option>
        </select>
        <ng-container *ngIf="szuro.szamla === '*'">
          <input class="karton-tart" type="text" [(ngModel)]="szuro.szlaTol" (keydown.enter)="betolt()" (blur)="betolt()" placeholder="számlától" title="Számlatartomány kezdete (pl. 3)">
          <input class="karton-tart" type="text" [(ngModel)]="szuro.szlaIg" (keydown.enter)="betolt()" (blur)="betolt()" placeholder="számláig" title="Számlatartomány vége – előtag szerint (a 4 a 4xx-eket is)">
        </ng-container>
      </ng-container>
      <!-- Főkönyvi kivonat: az üres sorok alapból rejtve; az aktív szűkítés chipként -->
      <ng-container *ngIf="ful === 'kivonat'">
        <label class="n-jelolo" title="Alapból csak az értékkel bíró sorok látszanak. Bekapcsolva a forgalom nélküli gyűjtő (összesítő) számlák is megjelennek.">
          <input type="checkbox" [ngModel]="kivonatSzuro.mind" (ngModelChange)="kivonatMindValt($event)"> Mindent mutat</label>
      </ng-container>
      <span class="kivonat-chip" *ngFor="let c of aktivCimkek">{{ c }}</span>
      <button *ngIf="aktivCimkek.length" type="button" class="kivonat-torol" (click)="szuroTorol()">
        <ion-icon name="close-circle-outline"></ion-icon>szűkítés törlése</button>
      <label for="naploKereso">Gyorskeresés</label>
      <input id="naploKereso" #keresoMezo type="search" [ngModel]="keresesBe" (ngModelChange)="keresesValt($event)" placeholder="partner, bizonylatszám, megjegyzés…" autocomplete="off">
      <select [(ngModel)]="keresesMod" title="Keresési mód">
        <option value="tartalmaz">Tartalmazza</option>
        <option value="eleje">Eleje egyezik</option>
      </select>
      <label class="n-jelolo" *ngIf="ful === 'bank' || ful === 'penzugyi'">
        <input type="checkbox" [(ngModel)]="negativ" (ngModelChange)="epit()">
        {{ ful === 'bank' ? 'A kiadások negatív előjellel' : 'A szállító számlák negatív előjellel' }}
      </label>
      <span class="n-jelzo">{{ lathatoSorok.length }} tétel</span>
      <button type="button" class="n-ures-kapcs" *ngIf="rejtettOszlopDb || uresOszlopok" (click)="uresOszlopok = !uresOszlopok"
              [title]="uresOszlopok ? 'Az üres oszlopok elrejtése' : 'Az üres oszlopok is látszódjanak'">
        {{ uresOszlopok ? 'Üres oszlopok elrejtése' : '+' + rejtettOszlopDb + ' üres oszlop' }}
      </button>
    </div>

    <!-- A lista saját választói (a feltételek a Szűkítés ablakban vannak). -->
    <!-- ÁFA-analitika: megnyitáskor időszakválasztó (teljes év / negyedév / hónap), utána időszak + irány + kulcs szűrő.
         A bevallási időszak (az ügyfél ÁFA-gyakorisága) csoportja jelölve – a Kettős könyvelés ÁFA-nézetének címkéivel. -->
    <div class="afa-idoszak" *ngIf="ful === 'afa' && !afaIdoszak">
      <h3>Melyik időszak ÁFA-analitikáját nézzük? ({{ aktiv.ev }}<span class="afa-gyak" *ngIf="afaGyakorisagSzoveg"> · {{ afaGyakorisagSzoveg }} bevalló</span>)</h3>
      <div class="afa-ido-gombok">
        <button type="button" class="fo" (click)="afaIdoszakValaszt('ev')">Teljes év</button>
      </div>
      <div class="afa-ido-csoport" [class.bevallasi]="afaNegyedeves">Negyedév<span *ngIf="afaNegyedeves"> · bevallási időszak</span></div>
      <div class="afa-ido-gombok">
        <button type="button" *ngFor="let n of afaNegyedek; let i = index" (click)="afaIdoszakValaszt(afaNegyedKod(i))">{{ n }}</button>
      </div>
      <div class="afa-ido-csoport" [class.bevallasi]="afaHavi">Hónap<span *ngIf="afaHavi"> · bevallási időszak</span></div>
      <div class="afa-ido-gombok">
        <button type="button" *ngFor="let h of afaHonapok; let i = index" (click)="afaIdoszakValaszt(afaHoKod(i))">{{ h }}</button>
      </div>
    </div>
    <div class="n-szukites" *ngIf="ful === 'afa' && afaIdoszak">
      <label>Időszak
        <select [ngModel]="afaIdoszak" (ngModelChange)="afaIdoszakValaszt($event)">
          <option value="ev">Teljes év</option>
          <optgroup [label]="afaNegyedeves ? 'Negyedév (bevallási időszak)' : 'Negyedév'">
            <option *ngFor="let n of afaNegyedek; let i = index" [value]="afaNegyedKod(i)">{{ n }}</option>
          </optgroup>
          <optgroup [label]="afaHavi ? 'Hónap (bevallási időszak)' : 'Hónap'">
            <option *ngFor="let h of afaHonapok; let i = index" [value]="afaHoKod(i)">{{ h }}</option>
          </optgroup>
        </select>
      </label>
      <label>Irány
        <select [(ngModel)]="afaSzuro.irany" (ngModelChange)="betolt()">
          <option value="">Mind</option><option value="fizetendo">Fizetendő</option><option value="levonhato">Levonható</option>
        </select>
      </label>
      <label>Kulcs
        <select [(ngModel)]="afaSzuro.kulcs" (ngModelChange)="betolt()">
          <option value="">Mind</option><option *ngFor="let k of ['27', '18', '5', '0']" [value]="k">{{ k }}%</option>
        </select>
      </label>
    </div>

    <!-- ÁFA-ARÁNYOSÍTÁS (hónap / negyedév): ugyanaz a számítás, mint a Kettős könyvelés ÁFA-nézetében.
         Csak ha van mit arányosítani (adómentes bevétel, vagy már könyvelt arányosítás). -->
    <div class="afa-arany" *ngIf="aranyositasLathato">
      <div class="afa-arany-fej">
        <b>ÁFA-arányosítás – {{ afaIdoszakCimke }} ({{ aranyositas.idoszak }})</b>
        <span class="kesz" *ngIf="aranyositas.mar_konyvelt">· már könyvelve ({{ aranyositas.bizonylatszam }})</span>
        <span class="ter"></span>
        <label title="Az előzetes ÁFA (466) melyik bevallási sorának áfatartalmára vetítjük a hányadot">Vizsgált bevallási sor
          <input type="text" [(ngModel)]="aranyositasSor" (change)="aranyositasBetolt()"></label>
      </div>
      <div class="afa-arany-adatok">
        <span title="Adómentes (adólevonásra NEM jogosító) nettó bevétel, januártól az időszak végéig">Mentes nettó (göngyölített) <b>{{ szam(aranyositas.mentes_netto) }} Ft</b></span>
        <span title="Áfás (adólevonásra jogosító) nettó bevétel, januártól az időszak végéig">Áfás nettó (göngyölített) <b>{{ szam(aranyositas.afas_netto) }} Ft</b></span>
        <span title="Januártól az időszak végéig (göngyölített)">Összes nettó (göngyölített) <b>{{ szam(aranyositas.osszes_netto) }} Ft</b></span>
        <span title="Levonási hányad = áfás ÷ összes bevétel (január–időszak vége). Nincs mentes bevétel → 1; nincs áfás → 0.">Levonási hányad <b>{{ aranyositas.levonasi_hanyad }}</b></span>
        <span title="Az időszak vizsgált bevallási sorának (előzetes ÁFA) áfatartalma">{{ aranyositas.sor }}. sor áfája (időszak) <b>{{ szam(aranyositas.afa_68) }} Ft</b></span>
        <span title="Levonási hányad × az időszak áfája">Levonható <b class="poz">{{ szam(aranyositas.levonhato) }} Ft</b></span>
        <span title="(1 − levonási hányad) × az időszak áfája">Le nem vonható <b class="neg">{{ szam(aranyositas.le_nem_vonhato) }} Ft</b></span>
      </div>
      <div class="afa-arany-lab">
        <button type="button" *ngIf="aranyositasKonyvelheto" [disabled]="aranyositasFut || aranyositas.le_nem_vonhato <= 0" (click)="aranyositasKonyvel()">
          <ion-icon name="calculator-outline"></ion-icon>{{ aranyositas.mar_konyvelt ? 'Arányosítás frissítése' : 'Arányosítás könyvelése' }} (T {{ aranyositas.le_nem_vonhato_szamla }} / K {{ aranyositas.afa_szamla }})
        </button>
        <span *ngIf="aranyositasKonyvelheto">Az időszak utolsó napjára, önálló vegyes bizonylatként – az ÁFA-bevallás beadásakor.</span>
        <span *ngIf="!aranyositasKonyvelheto">Tájékoztató adat: könyvelni a bevallási időszakra lehet ({{ afaGyakorisagSzoveg }} bevalló{{ afaNegyedeves ? ' – válassz negyedévet' : afaHavi ? ' – válassz hónapot' : '' }}).</span>
      </div>
    </div>

    <div class="n-szukites" *ngIf="kivonatForras || ful === 'penzugyi'">
      <label *ngIf="kivonatForras">Státusz
        <select [(ngModel)]="szuro.statusz" (ngModelChange)="epit()">
          <option value="">Mind</option><option value="uj">új</option><option value="kontirozott">kontírozott</option>
          <option value="parositott">párosított</option><option value="konyvelt">könyvelt</option><option value="fuggo">függő</option>
        </select>
      </label>
      <label *ngIf="ful === 'penzugyi'">Nézet
        <select [ngModel]="pnNezet" (ngModelChange)="pnNezetValt($event)">
          <option value="vegyes">Vegyes (keltezés szerint)</option>
          <option value="csoport">Előbb a vevők, majd a szállítók (keltezés szerint)</option>
        </select>
      </label>
      <label *ngIf="ful === 'penzugyi'">Típus
        <select [(ngModel)]="szuro.tipus" (ngModelChange)="epit()">
          <option value="">Vevő és szállító</option><option value="vevo">Vevő</option><option value="szallito">Szállító</option>
        </select>
      </label>
      <label *ngIf="ful === 'penzugyi'">Állapot
        <select [(ngModel)]="szuro.allapot" (ngModelChange)="epit()">
          <option value="">Mind</option><option value="nyitott">Nyitott</option><option value="lejart">Lejárt</option><option value="rendezett">Rendezett</option>
        </select>
      </label>
    </div>

    <div class="n-szukites" *ngIf="ful === 'eszkoz'">
      <label>Nézet
        <select [ngModel]="eszkozNezet" (ngModelChange)="eszkozNezetValt($event)">
          <option value="naplo">Napló (az év mozgásai időrendben)</option>
          <option value="tabla">Mozgástábla (csoportonként)</option>
        </select>
      </label>
    </div>

    <!-- A forrás a sáv fölött is látszik (a bank naplónál ettől függ az egyenleg). -->
    <div class="n-forras-sav" *ngIf="ful === 'bank' && forrasok.length > 1">
      <button *ngFor="let f of forrasok" type="button" [class.aktiv]="szuro.forras === f.id" (click)="forrasValt(f.id)">{{ f.nev }}</button>
    </div>

    <div class="n-merleg-jel" *ngIf="ful === 'gyorsmerleg' && merlegEgyensuly !== null" [class.rossz]="!merlegEgyensuly">
      <ion-icon [name]="merlegEgyensuly ? 'checkmark-circle' : 'alert-circle'"></ion-icon>
      {{ merlegEgyensuly ? 'A mérleg egyensúlyban van.' : 'A mérleg NINCS egyensúlyban – nézd át a nyitó és a záró tételeket.' }}
    </div>

    <div class="ures" *ngIf="betoltes"><ion-spinner name="dots"></ion-spinner></div>
    <div class="ures" *ngIf="!betoltes && hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ hiba }}</div>
    <div class="ures" *ngIf="!betoltes && !hiba && !lathatoSorok.length && !(ful === 'afa' && !afaIdoszak)"><ion-icon name="reader-outline"></ion-icon>Nincs megjeleníthető tétel.</div>

    <div class="tabla-wrap" *ngIf="!betoltes && lathatoSorok.length" (scroll)="racsGorget($event)">
      <table class="n-racs" [class.tomor]="tomor">
        <thead>
          <tr><th *ngFor="let o of lathatoOszlopok" [class.num]="o.num" [class.jel-oszlop]="o.k === 'jel'" [ngClass]="o.cs || ''" [title]="o.cim || o.c">{{ o.c }}</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rajzoltSorok; trackBy: sorTrack" [ngClass]="sorOsztaly(r)" (click)="kijelol(r)" (dblclick)="dupla(r)"
              [title]="r._tulfizetett ? 'Túlfizetett számla – a rendezett összeg több a végösszegnél' : r._athozott ? 'Előző évről áthozott számla – csak a pénzügyi nyilvántartásban szerepel' : ''">
            <td *ngFor="let o of lathatoOszlopok" [class.num]="o.num" [ngClass]="o.cs || ''" [class.neg]="negativE(r, o)"
                [class.szeles]="o.szeles" [class.jel-oszlop]="o.k === 'jel'" [title]="o.szeles ? (r[o.k] || '') : ''">
              <ng-container [ngSwitch]="o.k">
                <span *ngSwitchCase="'statusz'" class="allapot" [attr.data-a]="r.statusz">{{ r.statusz }}</span>
                <span *ngSwitchCase="'lejar'" class="lejar" [attr.data-a]="r.lejar">{{ r.lejar }}</span>
                <span *ngSwitchCase="'jel'" title="Van jegyzet">{{ r.jel }}</span>
                <ng-container *ngSwitchDefault>{{ ertek(r, o) }}</ng-container>
              </ng-container>
            </td>
          </tr>
          <!-- Fokozatos rajzolás: a többi sor görgetésre, vagy ide kattintva jön (az összesen a teljes listáé). -->
          <tr class="n-tovabb" *ngIf="hatralevoSorDb">
            <td [attr.colspan]="lathatoOszlopok.length">
              … még <b>{{ hatralevoSorDb }}</b> tétel
              <button type="button" class="ov-gomb" (click)="sorokMutat()">Következő {{ hatralevoSorDb > 200 ? 200 : hatralevoSorDb }}</button>
              <button type="button" class="ov-gomb" *ngIf="hatralevoSorDb > 200" (click)="sorokMutat(true)">Mind</button>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="osszegzes && osszegzesVan">
          <tr>
            <td *ngFor="let o of lathatoOszlopok; let i = index" [class.num]="o.num" [ngClass]="o.cs || ''">
              <ng-container *ngIf="i === 1 || (i === 0 && o.k !== 'jel')">Összesen</ng-container>
              <ng-container *ngIf="o.osszeg">{{ szam(osszeg(o)) }}</ng-container>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- SOR-MŰVELETEK (a kiválasztott sorra) – RLB mintájára gombsor a rács alatt.
         Kattintás = kijelölés, dupla kattintás / Enter = módosítás, Delete = törlés, Insert = új. -->
    <div class="n-muveletek" *ngIf="muveletek.length">
      <button *ngFor="let m of muveletek; trackBy: muvTrack" type="button" [class.tiltott]="!!tiltva(m)" [title]="tiltva(m) || m.c" (click)="futtat(m)">
        <ion-icon [name]="m.ikon"></ion-icon><span>{{ m.c }}</span>
      </button>
      <span class="n-muv-sugo" *ngIf="!kijelolt">Kattints egy sorra a műveletekhez.</span>
    </div>
  </div>
</div>

<p class="n-megj" *ngIf="ful === 'eszkoz'">
  Az adat a Tárgyi eszköz modulból jön (eszközök, écs-feladások, értékvesztés, kivezetés) – ott rögzíthető és módosítható.
  A csökkenés a kivezetés, a törlesztés és a visszaírás; nyitó + növekedés − csökkenés = záró.
</p>
<p class="n-megj" *ngIf="kivonatForras">
  A nyitó és a záró egyenleg a szinkronizált banki tételekből göngyölődik (a bank a számla egyenlegét nem közli).
</p>

<!-- ═══════════════ ABLAKOK ═══════════════ -->
<ion-modal [isOpen]="!!modal" (didDismiss)="zar()" [cssClass]="'nk-modal nk-' + (modal || '')">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>{{ modalCim }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="zar()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <!-- Tartalomhoz méretezett ablak: sima div (ion-content auto magasságnál nem méreteződik). -->
    <div class="nk-torzs">
      <div class="nk">

        <!-- Jegyzet -->
        <ng-container *ngIf="modal === 'jegyzet'">
          <p class="nk-al">{{ m.cim }}</p>
          <textarea class="nk-szoveg" rows="8" [(ngModel)]="m.szoveg" placeholder="Jegyzet a sorhoz… (üresen mentve törlődik)"></textarea>
          <div class="nk-lab"><button type="button" class="ov-gomb fo" [disabled]="mFut" (click)="jegyzetMent()">Mentés</button></div>
        </ng-container>

        <!-- Kiegyenlítés könyvelése -->
        <ng-container *ngIf="modal === 'kiegyKonyv'">
          <p class="nk-al"><b>{{ m.k.bizonylatszam }}</b> · {{ m.k.partner_nev }} · hátralék: <b>{{ szam(m.hatralek) }} {{ m.k.deviza || 'HUF' }}</b></p>
          <div class="nk-racs">
            <label class="kv-mezo"><span>Dátum</span><input type="date" [(ngModel)]="m.datum"></label>
            <label class="kv-mezo"><span>Összeg</span><input type="number" step="0.01" [(ngModel)]="m.osszeg"></label>
            <label class="kv-mezo"><span>Módja</span>
              <select [(ngModel)]="m.modja">
                <option value="bank">Bank</option><option value="penztar">Pénztár (készpénz)</option>
                <option value="beszamitas">Beszámítás / kompenzáció</option><option value="kezi">Egyéb (kézi)</option>
              </select></label>
            <label class="kv-mezo"><span>Bizonylatsz.</span><input type="text" [(ngModel)]="m.bizonylatszam" placeholder="pl. pénztárbizonylat száma"></label>
            <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="m.megjegyzes"></label>
          </div>
          <label class="nk-jel" *ngIf="kettos && !m.devizas && (m.modja === 'penztar' || m.modja === 'bank')">
            <input type="checkbox" [(ngModel)]="m.konyvel"> Bizonylat is készüljön ({{ m.modja === 'penztar' ? 'pénztár' : 'bank' }} napló: {{ m.k.tipus === 'vevo' ? 'T pénz – K vevő' : 'T szállító – K pénz' }})
          </label>
          <p class="nk-figy" *ngIf="m.devizas">Devizás számla: csak a kiegyenlítés rögzül; a forintos bizonylat a banki párosításból vagy kézzel készül (árfolyam!).</p>
          <p class="nk-figy" *ngIf="!kettos">Egyszeres könyvelésnél a kifizetés a naplófőkönyvben tételként rögzül – itt a számla rendezettsége vezetődik.</p>
          <div class="nk-lab"><button type="button" class="ov-gomb fo" [disabled]="mFut || !(m.osszeg > 0)" (click)="kiegyKonyvMent()">Rögzítés</button></div>
        </ng-container>

        <!-- Kiegyenlítés beállítása -->
        <ng-container *ngIf="modal === 'kiegyBeall'">
          <p class="nk-al"><b>{{ m.k.bizonylatszam }}</b> · {{ m.k.partner_nev }} · végösszeg: <b>{{ szam(m.k.brutto) }} {{ m.k.deviza || 'HUF' }}</b></p>
          <div class="nk-racs">
            <label class="kv-mezo"><span>Kiegyenlítve</span><input type="number" step="0.01" [(ngModel)]="m.kiegyenlitett"></label>
            <label class="kv-mezo"><span>Fiz. határidő</span><input type="date" [(ngModel)]="m.fizetesi_hatarido"></label>
            <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="m.megjegyzes"></label>
            <label class="kv-mezo"><span>Indok</span><input type="text" [(ngModel)]="m.indok" placeholder="miért állítod (a Rendezésekben látszik)"></label>
          </div>
          <div class="nk-lab"><button type="button" class="ov-gomb fo" [disabled]="mFut" (click)="kiegyBeallMent()">Beállítás</button></div>
        </ng-container>

        <!-- Rendezések -->
        <ng-container *ngIf="modal === 'rendezesek'">
          <div class="ures" *ngIf="m.betolt"><ion-spinner name="dots"></ion-spinner></div>
          <ng-container *ngIf="!m.betolt && m.szamla">
            <p class="nk-al"><b>{{ m.szamla.bizonylatszam }}</b> · {{ m.szamla.partner_nev }} · végösszeg {{ szam(m.szamla.brutto) }} ·
              rendezve {{ szam(m.szamla.kiegyenlitett) }} · hátralék <b>{{ szam(m.szamla.hatralek) }}</b> {{ m.szamla.deviza }}</p>
            <div class="tabla-wrap">
              <table class="n-racs">
                <thead><tr><th>Dátum</th><th>Módja</th><th class="num">Összeg</th><th>Hivatkozás</th><th>Megjegyzés</th><th></th></tr></thead>
                <tbody>
                  <tr *ngFor="let x of m.rendezesek">
                    <td>{{ x.datum }}</td><td>{{ modjaNev(x.modja) }}</td><td class="num">{{ szam(x.osszeg) }}</td>
                    <td>{{ x.hivatkozas }}</td><td class="szeles">{{ x.megjegyzes }}</td>
                    <td><button *ngIf="x.kezi" type="button" class="ov-link" (click)="rendezesVissza(x)">Visszavonás</button>
                      <span *ngIf="!x.kezi" class="halvany" title="Banki párosítás – a Pénztár/Bank naplóban a „Hivatkozás törlése” vonja vissza">banki</span></td>
                  </tr>
                </tbody>
              </table>
              <div class="ures" *ngIf="!m.rendezesek?.length">Még nincs rendezés.</div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Bankszámla-történet -->
        <ng-container *ngIf="modal === 'bankTortenet'">
          <div class="ures" *ngIf="m.betolt"><ion-spinner name="dots"></ion-spinner></div>
          <ng-container *ngIf="!m.betolt">
            <p class="nk-al"><b>{{ m.partner }}</b><span *ngIf="m.torzs_szamla"> · a partnertörzsben: {{ m.torzs_szamla }}</span></p>
            <div class="nk-cim">Bankszámlák, amelyekről / amelyekre pénz mozgott</div>
            <div class="tabla-wrap">
              <table class="n-racs">
                <thead><tr><th>Bankszámla</th><th class="num">Tételek</th><th class="num">Bejövő</th><th class="num">Kimenő</th><th>Első</th><th>Utolsó</th></tr></thead>
                <tbody><tr *ngFor="let s of m.szamlak"><td><b>{{ s.szamla }}</b></td><td class="num">{{ s.db }}</td><td class="num">{{ szam(s.bejovo) }}</td><td class="num">{{ szam(s.kimeno) }}</td><td>{{ s.elso }}</td><td>{{ s.utolso }}</td></tr></tbody>
              </table>
              <div class="ures" *ngIf="!m.szamlak?.length">Nincs banki tétel ezzel a partnerrel.</div>
            </div>
            <div class="nk-cim" *ngIf="m.tranzakciok?.length">Banki tételek ({{ m.tranzakciok.length }})</div>
            <div class="tabla-wrap nk-lista" *ngIf="m.tranzakciok?.length">
              <table class="n-racs">
                <thead><tr><th>Dátum</th><th>Saját számla</th><th>Partner számlája</th><th class="num">Összeg</th><th>Közlemény</th><th>Státusz</th></tr></thead>
                <tbody><tr *ngFor="let t of m.tranzakciok"><td>{{ t.datum }}</td><td>{{ t.iban }}</td><td>{{ t.partner_szamla }}</td>
                  <td class="num" [class.neg]="t.osszeg < 0">{{ szam(t.osszeg) }}</td><td class="szeles">{{ t.kozlemeny }}</td>
                  <td><span class="allapot" [attr.data-a]="t.statusz">{{ t.statusz }}</span></td></tr></tbody>
              </table>
            </div>
          </ng-container>
        </ng-container>

        <!-- Utólagos összepontozás -->
        <ng-container *ngIf="modal === 'osszepontozas'">
          <div class="ures" *ngIf="m.betolt"><ion-spinner name="dots"></ion-spinner></div>
          <ng-container *ngIf="!m.betolt && m.bizonylat">
            <p class="nk-al"><b>{{ m.bizonylat.bizonylatszam || 'bizonylat' }}</b> · {{ m.bizonylat.partner_nev }} · {{ m.bizonylat.megnevezes }}</p>
            <p class="nk-figy" *ngIf="!m.labak?.length">A bizonylatnak nincs vevő- vagy szállító-számlás lába, ezért nincs mit számlához kötni.</p>
            <ng-container *ngIf="m.labak?.length">
              <p class="nk-al">Pontozható partner-láb: <b>{{ szam(m.pontozhato) }}</b> (már pontozva: {{ szam(m.pontozott) }}) · most kijelölve: <b>{{ szam(pontOsszeg) }}</b></p>
              <div class="nk-cim" *ngIf="m.meglevo?.length">Már összepontozott számlák</div>
              <div class="tabla-wrap" *ngIf="m.meglevo?.length">
                <table class="n-racs"><tbody>
                  <tr *ngFor="let x of m.meglevo"><td>{{ x.bizonylatszam }}</td><td>{{ x.partner_nev }}</td><td class="num">{{ szam(x.osszeg) }}</td>
                    <td><button type="button" class="ov-link" (click)="pontVissza(x)">Visszavonás</button></td></tr>
                </tbody></table>
              </div>
              <div class="nk-cim">Nyitott számlák (a bizonylat partnere elöl)</div>
              <div class="tabla-wrap nk-lista">
                <table class="n-racs">
                  <thead><tr><th></th><th>Típus</th><th>Bizonylatszám</th><th>Partner</th><th>Kelt</th><th class="num">Hátralék</th><th class="num">Pontozott összeg</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let n of m.nyitott" [class.kijelolt]="m.valaszt[n.id] != null">
                      <td><input type="checkbox" [checked]="m.valaszt[n.id] != null" (change)="pontValt(n, $any($event.target).checked)"></td>
                      <td>{{ n.tipus === 'vevo' ? 'Vevő' : 'Szállító' }}</td><td>{{ n.bizonylatszam }}</td><td>{{ n.partner_nev }}</td><td>{{ n.kelt }}</td>
                      <td class="num">{{ szam(n.hatralek) }}</td>
                      <td class="num"><input *ngIf="m.valaszt[n.id] != null" class="nk-szam" type="number" step="0.01" [(ngModel)]="m.valaszt[n.id]"></td>
                    </tr>
                  </tbody>
                </table>
                <div class="ures" *ngIf="!m.nyitott?.length">Nincs nyitott (forintos) számla.</div>
              </div>
              <div class="nk-lab"><button type="button" class="ov-gomb fo" [disabled]="mFut || !pontOsszeg" (click)="pontMent()">Összepontozás ({{ szam(pontOsszeg) }})</button></div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- Számla felvétele / módosítása (pénzügyi nyilvántartás) -->
        <ng-container *ngIf="modal === 'kiegySzerk'">
          <app-szerk-zar-sav [zar]="zarKiegy"></app-szerk-zar-sav>
          <div class="nk-racs">
            <label class="kv-mezo"><span>Típus</span><select [(ngModel)]="m.tipus"><option value="vevo">Vevő (kimenő)</option><option value="szallito">Szállító (bejövő)</option></select></label>
            <label class="kv-mezo"><span>Partner</span><input type="text" [(ngModel)]="m.partner_nev"></label>
            <label class="kv-mezo"><span>Bizonylatsz.</span><input type="text" [(ngModel)]="m.bizonylatszam"></label>
            <label class="kv-mezo"><span>Kelt</span><input type="date" [(ngModel)]="m.kelt"></label>
            <label class="kv-mezo"><span>Teljesítés</span><input type="date" [(ngModel)]="m.teljesites"></label>
            <label class="kv-mezo"><span>Fiz. határidő</span><input type="date" [(ngModel)]="m.fizetesi_hatarido"></label>
            <label class="kv-mezo"><span>Áfa esed.</span><input type="date" [(ngModel)]="m.afa_esedekesseg"></label>
            <label class="kv-mezo"><span>Nettó</span><input type="number" step="0.01" [(ngModel)]="m.netto"></label>
            <label class="kv-mezo"><span>ÁFA</span><input type="number" step="0.01" [(ngModel)]="m.afa"></label>
            <label class="kv-mezo"><span>Bruttó</span><input type="number" step="0.01" [(ngModel)]="m.brutto" placeholder="nettó + ÁFA"></label>
            <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="m.megjegyzes"></label>
          </div>
          <p class="nk-figy" *ngIf="m.id">A kiegyenlített összeg itt nem változik – arra a „Kiegyenlítés könyvelése / beállítása" való.</p>
          <div class="nk-lab"><button type="button" class="ov-gomb fo" [disabled]="mFut || !m.bizonylatszam || zarTilt(zarKiegy)" (click)="kiegySzerkMent()">Mentés</button></div>
        </ng-container>

        <!-- Banki tétel módosítása (kettős) – helyben, a könyvelőoldal nélkül -->
        <ng-container *ngIf="modal === 'bankSzerk'">
          <ng-container *ngIf="m.konyveletlen">
            <p class="nk-al">Ez a banki tétel még nincs lekönyvelve – a kontírozása (ellenszámla, partner-párosítás) a Bank → Kontírozás oldalon van.</p>
            <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="bankTeljesSzerkeszto()">Kontírozás megnyitása</button></div>
          </ng-container>
          <ng-container *ngIf="!m.konyveletlen">
            <app-szerk-zar-sav [zar]="zarBank"></app-szerk-zar-sav>
            <div class="nk-racs">
              <label class="kv-mezo"><span>Dátum</span><input type="date" [(ngModel)]="m.datum"></label>
              <label class="kv-mezo"><span>Bizonylatsz.</span><input type="text" [(ngModel)]="m.bizonylatszam"></label>
              <label class="kv-mezo"><span>Partner</span><input type="text" [(ngModel)]="m.partner_nev"></label>
              <label class="kv-mezo"><span>Megnevezés</span><input type="text" [(ngModel)]="m.megnevezes"></label>
            </div>
            <table class="naplo-tabla nk-banksorok">
              <thead><tr><th>Számla</th><th class="num">Tartozik</th><th class="num">Követel</th><th>Megjegyzés</th><th></th></tr></thead>
              <tbody>
                <tr *ngFor="let s of m.sorok; let i = index">
                  <td><input type="text" [(ngModel)]="s.szamlaszam" style="width:90px"></td>
                  <td class="num"><input type="number" step="1" [(ngModel)]="s.tartozik" style="width:120px;text-align:right"></td>
                  <td class="num"><input type="number" step="1" [(ngModel)]="s.kovetel" style="width:120px;text-align:right"></td>
                  <td><input type="text" [(ngModel)]="s.megjegyzes"></td>
                  <td><button type="button" class="ov-link" (click)="bankSorTorol(i)" title="Sor törlése">×</button></td>
                </tr>
              </tbody>
              <tfoot><tr><td>Összesen</td><td class="num">{{ szam(bankOsszeg('tartozik')) }}</td><td class="num">{{ szam(bankOsszeg('kovetel')) }}</td>
                <td colspan="2"><span [class.neg]="!bankEgyensuly">{{ bankEgyensuly ? 'egyensúlyban' : 'nincs egyensúlyban' }}</span></td></tr></tfoot>
            </table>
            <div class="nk-lab">
              <button type="button" class="ov-gomb" (click)="bankSor()">+ Sor</button>
              <button type="button" class="ov-gomb" (click)="bankTeljesSzerkeszto()" title="A bizonylat a teljes könyvelőablakban (ÁFA, munkaszám, deviza…)">Teljes szerkesztő</button>
              <button type="button" class="ov-gomb fo" [disabled]="mFut || !bankEgyensuly || zarTilt(zarBank)" (click)="bankSzerkMent()">Mentés</button>
            </div>
          </ng-container>
        </ng-container>

      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Főkönyvi kivonat – Szűkítés (közös ablak, a könyvelés nézet kivonata is ezt használja) -->
<app-kivonat-szukites [nyitva]="kivonatSzukitesNyitva" [szuro]="aktivSzuro" [ugyfelId]="aktiv.ugyfelId"
  [mod]="ful === 'kivonat' ? 'kivonat' : 'naplo'" [mezok]="szukitesMezok"
  (szukit)="szukitesKesz($event)" (bezar)="kivonatSzukitesNyitva = false"></app-kivonat-szukites>

<!-- RLB-IMPORT: pénzügyi nyilvántartás + pénztár-bank napló (naplo-rlb-import.js) -->
<ion-modal [isOpen]="rlb.nyitva" (didDismiss)="rlb.nyitva = false" cssClass="nk-modal nk-rlb">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>RLB-import – {{ aktiv.ugyfelNev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="rlb.nyitva = false">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <p class="rlb-sugo">Az RLB <b>pénzügyi nyilvántartás</b>, <b>pénztár-bank napló</b> és <b>vegyes napló</b> exportja (xls). A számlák vevői / szállítói
        bizonylatként, az RLB sorszámával kerülnek be, a pénzmozgások a már letöltött banki tételekhez párosítva – úgy, mintha itt
        könyvelted volna. Ami már bent van, kimarad (újrafuttatható). A bevétel / költség számlát az RLB nem exportálja: a partnerre
        tanult szabály vagy az alapértelmezés adja – az előnézetben soronként átírható.</p>
      <div class="rlb-dobo" [class.rajta]="rlb.rajta" (dragover)="$event.preventDefault(); rlb.rajta = true" (dragleave)="rlb.rajta = false"
           (drop)="$event.preventDefault(); rlb.rajta = false; rlbFajlok($any($event).dataTransfer?.files)" (click)="rlbInput.click()">
        <ion-icon name="cloud-upload-outline"></ion-icon>
        <b>Húzd ide az RLB-exportokat, vagy kattints a tallózáshoz</b>
        <span>Egyszerre mind: pénzügyi nyilvántartás, pénztár-bank napló, vegyes napló, <b>nyitó napló</b> és az <b>összes napló számlasorosan</b> (ebből jön a pontos kontírozás) – xls. A program felismeri, melyik melyik.</span>
        <input #rlbInput type="file" accept=".xls,.xlsx" multiple hidden (change)="rlbFajlok($any($event.target).files); $any($event.target).value = ''">
      </div>
      <div class="rlb-lista" *ngIf="rlb.fajlok.length">
        <div *ngFor="let f of rlb.fajlok; let i = index">
          <ion-icon name="document-outline"></ion-icon>{{ f.name }}
          <span class="halvany">{{ rlbFelismert(f.name) }}</span>
          <button type="button" class="ov-gomb" (click)="rlbTorol(i)" title="Kivesz"><ion-icon name="close"></ion-icon></button>
        </div>
        <button type="button" class="ov-gomb" (click)="rlbElonezet()" [disabled]="rlb.fut"><ion-icon name="eye-outline"></ion-icon>Előnézet</button>
      </div>
      <ion-progress-bar type="indeterminate" *ngIf="rlb.fut"></ion-progress-bar>

      <ng-container *ngIf="rlb.elonezet as e">
        <div class="rlb-osszeg">
          <div><span>Számla</span><b>{{ e.osszegzes.szamla.uj || 0 }} új</b><small>{{ e.osszegzes.szamla.mar_konyvelt || 0 }} már könyvelt · {{ e.osszegzes.szamla.elozo_ev || 0 }} előző évi (nyitott tételként)</small></div>
          <div><span>Bank</span><b>{{ e.osszegzes.bank.parosit || 0 }} párosítva</b><small>{{ e.osszegzes.bank.uj_tranzakcio || 0 }} új tranzakció · {{ e.osszegzes.bank.mar_konyvelt || 0 }} már könyvelt</small></div>
          <div><span>Pénztár</span><b>{{ e.osszegzes.penztar.uj || 0 }} új</b><small>{{ e.osszegzes.penztar.uj_fuggo || 0 }} függő (bekerül) · {{ e.osszegzes.penztar.nincs_szamla || 0 }} hivatkozás nélkül (kimarad) · {{ e.osszegzes.penztar.mar_konyvelt || 0 }} már könyvelt</small></div>
          <div><span>Partner</span><b>{{ e.osszegzes.partner_uj }} új</b><small>az RLB partnerkódjával</small></div>
          <div><span>Kontírozás</span><b>{{ e.osszegzes.pontos ? 'RLB szerint' : 'becsült' }}</b><small>{{ e.osszegzes.pontos ? 'a számlasoros összes naplóból, lábról lábra' : 'számlasoros összes napló nélkül: tanult szabály / alapértelmezés' }}</small></div>
          <div><span>Nyitás</span><b>{{ e.osszegzes.nyito?.db || 0 }} tétel</b><small>{{ rlbNyitoSzoveg(e.osszegzes.nyito) }}</small></div>
          <div *ngIf="e.vegyesek?.length"><span>Vegyes napló</span><b>{{ rlbVegyesDb('uj') }} könyvelendő</b><small>{{ e.osszegzes.vegyes_par }} rendezés-pár · {{ rlbVegyesDb('bank_szamolja') }} árfolyam (a bank-könyvelés zárja) · {{ rlbVegyesKimarad.length }} kimarad</small></div>
        </div>
        <h4>Új számlák – bevétel / költség számla</h4>
        <table class="n-racs rlb-tabla">
          <thead><tr><th>RLB</th><th>Kelt</th><th>Bizonylatszám</th><th>Partner</th><th class="num">Bruttó</th><th>Partner-fk.</th><th>Ellenszámla</th><th>Forrás</th></tr></thead>
          <tbody>
            <tr *ngFor="let s of rlbUjSzamlak">
              <td>{{ s.rlb }}</td><td>{{ s.kelt }}</td><td>{{ s.bizonylatszam }}</td>
              <td>{{ s.partner }}<span class="halvany" *ngIf="s.partner_uj"> (új)</span></td>
              <td class="num">{{ s.brutto | number:'1.0-0' }}{{ s.deviza ? ' (' + s.deviza_osszeg + ' ' + s.deviza + ')' : '' }}</td>
              <td>{{ s.partner_szamla }}</td>
              <td><input class="rlb-szla" [(ngModel)]="rlb.felulir[s.rlb]" [placeholder]="s.ellenszamla" [title]="s.ellenszamla_forras === 'RLB' ? 'Az RLB kontírozása – csak akkor írd át, ha mást akarsz' : ''"></td>
              <td class="halvany">{{ rlb.felulir[s.rlb] ? 'kézi' : s.ellenszamla_forras }}</td>
            </tr>
          </tbody>
        </table>
        <div class="rlb-fuggo-figy" *ngIf="e.osszegzes.fuggo_hiany && (rlbKimarado.length || rlbVegyesKimarad.length)">
          Nincs könyvelhető <b>függő technikai számla</b> ({{ e.osszegzes.fuggo_szamla_kert || '3898' }}) ennél az ügyfélnél – a hivatkozás nélküli
          pénztár/vegyes sorok ezért kimaradnak. Vedd fel a {{ e.osszegzes.fuggo_szamla_kert || '3898' }} számlát a számlatükörbe (könyvelhető,
          nem gyűjtő), vagy állíts be másikat a kettős könyvelés beállításaiban (függő számla), és futtasd újra.
        </div>
        <ng-container *ngIf="rlbFuggo.length">
          <h4>Függő ellenszámlával bekerülő tételek <small class="halvany">({{ e.osszegzes.fuggo_szamla || '3898' }} – az ellenszámla utólag pótolandó)</small></h4>
          <table class="n-racs rlb-tabla">
            <tbody>
              <tr *ngFor="let f of rlbFuggo"><td>{{ f.rlb }}</td><td>{{ f.datum }}</td><td>{{ f.megjegyzes || f.partner }}</td>
                <td class="num">{{ f.osszeg | number:'1.0-0' }}</td><td class="halvany">{{ rlbAllapot(f) }}</td></tr>
            </tbody>
          </table>
        </ng-container>
        <h4>Pénzmozgások, amelyek nem kerülnek be</h4>
        <table class="n-racs rlb-tabla">
          <tbody>
            <tr *ngFor="let p of rlbKimarado"><td>{{ p.rlb }}</td><td>{{ p.datum }}</td><td>{{ p.partner }}</td><td class="num">{{ p.osszeg | number:'1.0-0' }}</td>
              <td class="halvany">{{ rlbAllapot(p) }}{{ p.figyelmeztetes ? ' – ' + p.figyelmeztetes : '' }}</td></tr>
            <tr *ngFor="let v of rlbVegyesKimarad"><td>{{ v.rlb }}</td><td>{{ v.datum }}</td><td>{{ v.megjegyzes || v.partner }}</td><td class="num">{{ v.osszeg | number:'1.0-0' }}</td>
              <td class="halvany">{{ rlbAllapot(v) }}</td></tr>
            <tr *ngIf="!rlbKimarado.length && !rlbVegyesKimarad.length"><td class="halvany">Nincs ilyen.</td></tr>
          </tbody>
        </table>
        <p class="rlb-sugo">A számlára nem hivatkozó banki tételeket a bank-kontírozó szabályai kontírozzák; ha nincs valódi szabály, a tétel függő marad, és a Bank kontírozás képernyőn rendezhető.</p>
        <div class="rlb-lab">
          <button type="button" class="ov-gomb fo" (click)="rlbImport()" [disabled]="rlb.fut"><ion-icon name="cloud-upload-outline"></ion-icon>Import</button>
          <button type="button" class="ov-gomb" (click)="rlbVisszavon()" [disabled]="rlb.fut" title="Az előző RLB-import minden bizonylatának törlése – pl. mielőtt pontosabb exporttal újra futtatod">
            <ion-icon name="arrow-undo-outline"></ion-icon>Korábbi RLB-import visszavonása</button>
        </div>
      </ng-container>

      <div class="rlb-eredmeny" *ngIf="rlb.eredmeny as r">
        <b>Kész.</b> {{ r.partner }} partner, {{ r.szamla }} számla, {{ r.elozo_ev }} előző évi nyitott tétel, {{ r.penztar }} pénztár-bizonylat,
        {{ r.bank_konyvelt }} banki tétel könyvelve ({{ r.bank_parositva }} számlára párosítva, {{ r.bank_uj_tranzakcio }} új tranzakció),
        {{ r.nyito ? r.nyito + ' nyitótétel, ' : '' }}{{ r.vegyes_pontos ? r.vegyes_pontos + ' vegyes bizonylat (RLB szerint), ' : '' }}{{ r.vegyes_rendezes || 0 }} vegyes rendezés, {{ r.vegyes_afa || 0 }} fordított ÁFA, {{ r.arfolyam_zaras || 0 }} árfolyam-zárás,
        {{ r.beszamitas }} beszámítás, {{ r.kompenzacio }} kompenzáció.
        <div *ngIf="r.penztar_fuggo || r.vegyes_fuggo">Függő technikai ellenszámlával bekerült: {{ r.penztar_fuggo || 0 }} pénztár, {{ r.vegyes_fuggo || 0 }} vegyes tétel – az ellenszámlát utólag pótold.</div>
        <div *ngIf="r.fuggo_hiany" class="piros">{{ r.fuggo_hiany }}</div>
        <div *ngIf="r.vegyes_kimarad?.length">Kézzel / a Tárgyi eszköz modulban: {{ r.vegyes_kimarad.join('; ') }}</div>
        <div *ngIf="r.bank_fuggo">Függő (Bank kontírozás): {{ r.bank_fuggo }} – {{ (r.fuggo_lista || []).join('; ') }}</div>
        <div *ngFor="let x of r.rlb_elteres">{{ x }}</div>
        <div *ngFor="let x of r.hibak" class="piros">{{ x }}</div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- NYOMTATVÁNYOK: a pénzügyi nyilvántartás PDF-riportjai. A PDF-et a backend állítja elő
     (közös szerződés: POST /api/naplo/penzugy-nyomtatvany/:ugyfelId?ev=…); új böngészőlapon nyílik. -->
<ion-modal [isOpen]="nyomtatvanyNyitva" (didDismiss)="nyomtatvanyBezar()" cssClass="nk-modal nk-nyomtatvany">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Nyomtatványok</ion-title>
      <ion-buttons slot="end"><ion-button (click)="nyomtatvanyBezar()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk">
        <div class="nk-racs">
          <label class="kv-mezo"><span>Nyomtatás formátuma</span>
            <select [(ngModel)]="nyomtatvanyForm.format">
              <option *ngFor="let f of nyomtatvanyFormatumok" [value]="f.k">{{ f.c }}</option>
            </select>
          </label>
          <label class="kv-mezo"><span>Megjegyzés a lap tetején</span>
            <input type="text" [(ngModel)]="nyomtatvanyForm.megjegyzes" placeholder="szabad szöveg (üresen hagyható)">
          </label>
          <label class="kv-mezo" *ngIf="nyomtatvanyKorosit"><span>Fordulónap</span>
            <input type="date" [(ngModel)]="nyomtatvanyForm.fordulonap">
          </label>
        </div>

        <div class="nk-jelsor">
          <label class="nk-jel"><input type="checkbox" [(ngModel)]="nyomtatvanyForm.idopont"> Nyomtatás időpontjának megjelenítése</label>
          <label class="nk-jel"><input type="checkbox" [(ngModel)]="nyomtatvanyForm.datum"> Nyomtatás dátumának megjelenítése</label>
          <label class="nk-jel"><input type="checkbox" [(ngModel)]="nyomtatvanyForm.csikozas"> Tételsorok háttérszínének váltakozása</label>
        </div>

        <div class="nk-jelsor">
          <label class="nk-jel"><input type="radio" name="nytLista" [value]="false" [(ngModel)]="nyomtatvanyForm.csakSzurt"> Teljes lista</label>
          <label class="nk-jel"><input type="radio" name="nytLista" [value]="true" [(ngModel)]="nyomtatvanyForm.csakSzurt"> Kiválasztott (szűrt) tételek ({{ lathatoSorok.length }})</label>
        </div>

        <p class="nk-figy">A nyomtatási kép új lapon nyílik; onnan nyomtatható vagy menthető a böngésző PDF-nézőjéből.</p>
        <div class="nk-lab">
          <button type="button" class="ov-gomb" (click)="nyomtatvanyBezar()">Mégse</button>
          <button type="button" class="ov-gomb fo" [disabled]="nyomtatvanyFut" (click)="nyomtatvanyKeszit()">
            <ion-icon name="document-text-outline"></ion-icon>Nyomtatási kép
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
